<template>
  <div class="p-4 bg-white rounded-lg shadow overflow-x-auto">
    <table class="min-w-full text-sm text-left border-collapse">
      <thead>
        <tr class="font-normal text-center">
          <th class="px-4 py-4">
            Tug Owner
          </th>
          <th class="px-4 py-4">
            Actual Cost (USD/Ton)<br>
            {{ ytd }}
          </th>
          <th class="px-4 py-4">
            Coal Loaded<br>(Ton)
          </th>
          <th class="px-4 py-4">
            {{ handleValidateAndFormatNumber(ownerFuelOverview.volume_base_percent) }}<br><div class="text-center">
              (USD/Ton)
            </div>
          </th>
          <th class="px-4 py-4">
            {{ handleValidateAndFormatNumber(ownerFuelOverview.distance_base_percent) }}<br><div class="text-center">
              (USD/Nm)
            </div>
          </th>
          <th class="px-4 py-4">
            {{ handleValidateAndFormatNumber(ownerFuelOverview.top_quartile_barge_cycle) }}<br><div class="text-center">
              (Days)
            </div>
          </th>
          <th class="px-4 py-4">
            {{ handleValidateAndFormatNumber(ownerFuelOverview.liter_per_ton) }}<br><div class="text-center">
              (Liter/Ton)
            </div>
          </th>
          <th class="px-4 py-4">
            {{ handleValidateAndFormatNumber(ownerFuelOverview.liter_per_nm) }}<br><div class="text-center">
              (Liter/Nm)
            </div>
          </th>
          <th class="px-4 py-4">
            {{ handleValidateAndFormatNumber(ownerFuelOverview.cargo_capacity_utilization) }}%
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in tableData"
          :key="index"
          class="border-t"
        >
          <td class="px-4 py-4">
            {{ item.owner_name }}
          </td>
          <td class="px-4 py-4">
            {{ handleValidateAndFormatNumber(item.fuel_cost_per_ton) }}
          </td>
          <td class="px-4 py-4">
            {{ handleValidateAndFormatNumber(item.coal_loaded) }}
          </td>

          <td
            class="px-4 py-4"
            :class="getCellColor(item, 'volume_base_percent')"
          >
            {{ handleValidateAndFormatNumber(item.volume_base_percent) }}
          </td>
          <td
            class="px-4 py-4"
            :class="getCellColor(item, 'distance_base_percent')"
          >
            {{ handleValidateAndFormatNumber(item.distance_base_percent) }}
          </td>
          <td
            class="px-4 py-4"
            :class="getCellColor(item, 'top_quartile_barge_cycle')"
          >
            {{ handleValidateAndFormatNumber(item.top_quartile_barge_cycle) }}
          </td>
          <td
            class="px-4 py-4"
            :class="getCellColor(item, 'liter_per_ton')"
          >
            {{ handleValidateAndFormatNumber(item.liter_per_ton) }}
          </td>
          <td
            class="px-4 py-4"
            :class="getCellColor(item, 'liter_per_nm')"
          >
            {{ handleValidateAndFormatNumber(item.liter_per_nm) }}
          </td>
          <td
            class="px-4 py-4"
            :class="getCellColor(item, 'cargo_capacity_utilization')"
          >
            {{ handleValidateAndFormatNumber(item.cargo_capacity_utilization) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { isNumber } from '@/utils/salesPlanUtils'

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    ownerFuelOverview: {
      type: Object,
      default: () => {}
    },
    ytd: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    getCellColor(item, key) {
      const logicColor = key !== 'cargo_capacity_utilization' 
        ? item[key] > this.ownerFuelOverview[key] : item[key] < this.ownerFuelOverview[key]

      if (logicColor) {
        return 'redline text-white text-center'
      }
      return 'greenline text-white text-center'
    }
  }
}
</script>

<style scoped>
table {
  border-spacing: 0;
}
th, td {
  white-space: nowrap;
}
.redline {
  background-color: #FF3662;
}
.greenline {
  background-color: #33B57D;
}
</style>
